import { render } from "./App.vue?vue&type=template&id=ba2b50c8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ba2b50c8&lang=css"

import exportComponent from "/root/.jenkins/workspace/h5-official/official/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__